(function () {
   'use strict';

   module.exports = AssetCoreImage;
   var AssetCoreMedia = require('./media.js');
   var helper = require('../helpers/generic.js');
   var logger = new (require('../helpers/logger.js'))("ACMediaImage").setColor("goldenrod").setDebug(true);

  function AssetCoreImage(detailJson){
    AssetCoreMedia.call(this, detailJson); // call super constructor.
    logger.debug("creating AssetCoreImage with defaultQuality '"+this.defaultQualityName()+"' from json:", detailJson);
  }

  // subclass extends superclass
  AssetCoreImage.prototype = Object.create(AssetCoreMedia.prototype);
  AssetCoreImage.prototype.constructor = AssetCoreMedia;

  AssetCoreImage.prototype.width = function(quality){
    if (helper.undefOrNull(quality)){
      return this._defaultQuality().detail.width;
    } else {
      return this._getQuality(quality).detail.width;
    }
  };
  AssetCoreImage.prototype.height = function(quality){
    if (helper.undefOrNull(quality)){
      return this._defaultQuality().detail.height;
    } else {
      return this._getQuality(quality).detail.height;
    }
  };

  AssetCoreImage.prototype.ratio = function(qualityName){
    var height = this.height(qualityName);
    var width = this.width(qualityName);
    return width / height;
  };

  AssetCoreImage.prototype._standardQuality = function(){
    return this._getQuality("SQ");
  };
  AssetCoreImage.prototype._highQuality = function(){
    return this._getQuality("HQ");
  };

  // returns the correct url depending on the devices pixel ratio
  AssetCoreImage.prototype.dppxUrl = function(){
    var dppx = helper.getDppx();
    var url = null;
    if (dppx<=1){
      url = this.url();
    } else {
      url = this.retinaUrl() !== null ? this.retinaUrl() : this.url(); //fallback to SQ if no HQ available
    }
    return url;
  };

  AssetCoreImage.prototype.url = function(){
    return this._defaultQuality().detail.url;
  };

  AssetCoreImage.prototype.retinaUrl = function(){
    return this._highQuality() !== null ? this._highQuality().detail.url : null;
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/mediaImage.js
// module id = 24
// module chunks = 0